import LongText from '../../Elements/LongText';
import React from 'react';
import urlHelper from '../../Helpers/urlHelper';

export default class TpCreditMemoLineItem {
  constructor(item) {
    if (item) {
      this.TpCreditMemoLineId = item.tpCreditMemoLineId;
      this.Description = item.description;
      this.CreditAmount = item.creditAmount;
      this.CreditAmountReimb = item.creditAmountReimb;
      this.CreditAmountVat = item.creditAmountVat;
      this.CreditAmountVatReimb = item.creditAmountVatReimb;
      this.InitialTotal = item.initialTotal;
      this.CurrentTotal = item.currentTotal;
      this.Type = item.type === 'Job' ? 'Job' : 'Line Item';
      this.ThirdPartyJobId = item.thirdPartyJobId;
      this.JobLineId = item.jobLineId;
      this.LineItemId = item.lineItemId;
      this.CurrencyCode = item.currencyCode;
    } else {
      this.TpCreditMemoLineId = 0;
      this.Description = '';
      this.CreditAmount = 0;
      this.CreditAmountReimb = 0;
      this.CreditAmountVat = 0;
      this.CreditAmountVatReimb = 0;
      this.InitialTotal = 0;
      this.CurrentTotal = 0;
      this.Type = '';
      this.ThirdPartyJobId = 0;
      this.JobLineId = 0;
      this.LineItemId = 0;
      this.CurrencyCode = '';
    }
    this.Selected = false;
  }

  static MoneyFields = [
    'CreditAmount',
    'CreditAmountReimb',
    'CreditAmountVat',
    'CreditAmountVatReimb',
    'InitialTotal',
    'CurrentTotal',
  ];
  static Currency() {
    return 'CurrencyCode';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpCreditMemoLineItem.getSelectedCellHeader,
        orderById: '',
        data: TpCreditMemoLineItem.getSelectedCellContent,
        className: 'text-center',
        minWidth: 20,
      },
      { label: 'Line Credit ID', orderById: 'TpCreditMemoLineId', data: 'TpCreditMemoLineId' },
      {
        label: 'Description/Location',
        orderById: 'Description',
        data: (item) => (
          <LongText
            text={item.Description}
            maxLength={100}
          />
        ),
      },
      { label: 'Fee Credit', orderById: 'CreditAmount', data: 'CreditAmount' },
      { label: 'Reimb. Credit', orderById: 'CreditAmountReimb', data: 'CreditAmountReimb' },
      { label: 'Fee Tax Credit', orderById: 'CreditAmountVat', data: 'CreditAmountVat' },
      { label: 'Reimb. Tax Credit', orderById: 'CreditAmountVatReimb', data: 'CreditAmountVatReimb' },
      { label: 'Initial Total', orderById: 'InitialTotal', data: 'InitialTotal' },
      { label: 'Outstanding', orderById: 'CurrentTotal', data: 'CurrentTotal' },
      { label: 'Type', orderById: 'Type', data: 'Type' },
      { label: 'Third-Party Job ID', orderById: 'ThirdPartyJobId', data: TpCreditMemoLineItem.GetJobDetailCellContent },
      { label: 'Line Item ID', orderById: 'LineItemId', data: TpCreditMemoLineItem.GetLineItemDetailCellContent },
    ];
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={TpCreditMemoLineItem.selectedStatus()}
          onChange={(e) => {
            TpCreditMemoLineItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            TpCreditMemoLineItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static GetJobDetailCellContent(item) {
    if (item.Type !== 'Job') {
      return <div>{item.ThirdPartyJobId}</div>;
    }
    return urlHelper.getIconLinkComponentFigma(
      item.ThirdPartyJobId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'tpjobs/search',
      `ThirdPartyJobId=${item.ThirdPartyJobId}`,
      'Open up in a new tab'
    );
  }

  static GetLineItemDetailCellContent(item) {
    if (item.Type !== 'Line Item') {
      return <div>{item.LineItemId}</div>;
    }
    return urlHelper.getIconLinkComponentFigma(
      item.LineItemId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'tpclientinvoicelineitemdetails',
      `id=${item.LineItemId}`,
      'Open up in a new tab'
    );
  }
}
